import { motion } from 'motion/react';
// @mui
import { Container, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets';
import useLocales from '../hooks/useLocales';

export default function Forbidden() {
    const { translate } = useLocales();

    return (
        <Container component={MotionContainer} sx={{ textAlign: 'center', mt: 5 }}>
            <motion.div variants={varBounce().in}>
                <Typography variant="h3" paragraph>
                    {translate('components.forbidden.permissionDenied')}
                </Typography>
            </motion.div>

            <motion.div variants={varBounce().in}>
                <Typography sx={{ color: 'text.secondary' }}>
                    {translate('components.forbidden.noAccess')}
                </Typography>
            </motion.div>

            <motion.div variants={varBounce().in}>
                <ForbiddenIllustration aria-hidden sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
            </motion.div>
        </Container>
    );
}
